import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-pill',
  templateUrl: './pill.component.html',
  styleUrl: './pill.component.scss',
})
export class PillComponent {
  @Input() variant: (typeof variants)[number] = 'gray';
  @Input() size: (typeof sizes)[number] = 'default';
  @Input() isRemovable = false;

  @Output() handleRemove = new EventEmitter<void>();

  get ngClass() {
    return {
      [`variant-${this.variant}`]: true,
      [`size-${this.size}`]: true,
      ['app-pill']: true,
    };
  }

  handleClick() {
    this.handleRemove.emit();
  }
}

const variants = ['gray'] as const;

const sizes = ['default'] as const;
